import React, { CSSProperties, createElement } from 'react';
import ReactDOMServer from 'react-dom/server';
import { Serializer, Question, ElementFactory, IElement, SvgRegistry, SurveyError } from 'survey-core';
import { SurveyQuestionElementBase, ReactQuestionFactory } from 'survey-react-ui';
import { SurveyCreator } from 'survey-creator-react';
import { localization } from 'survey-creator-core';
import { BiSolidClinic } from 'react-icons/bi';
import RandoxSearchInput, { ClinicSlotSurveyData } from './Randox/RandoxSearchInput';

// This component is React based - follows https://surveyjs.io/form-library/documentation/customize-question-types/third-party-component-integration-react

export const CUSTOM_RANDOX_POSTCODE_CLINIC_SEARCH_QUESTION_TYPE = 'randox-postcode-clinic-search';

SvgRegistry.registerIconFromSvg(
  CUSTOM_RANDOX_POSTCODE_CLINIC_SEARCH_QUESTION_TYPE,
  ReactDOMServer.renderToString(<BiSolidClinic size="large" />)
);
const locale = localization.getLocale('');
locale.qt[CUSTOM_RANDOX_POSTCODE_CLINIC_SEARCH_QUESTION_TYPE] = 'Randox Clinic Location Search';

// Specifies all the "class" properties of a Region of Interest
export class RandoxPostcodeClinicSearch extends Question {
  getType() {
    return CUSTOM_RANDOX_POSTCODE_CLINIC_SEARCH_QUESTION_TYPE;
  }

  get clinicSlot(): (ClinicSlotSurveyData & { isNotInRandoxCatchment: boolean }) | undefined {
    return this.value || {};
  }

  hasErrors() {
    if (this.clinicSlot?.slotId) return false;

    this.clearErrors();

    if (!this.clinicSlot?.slotId) {
      this.addError(new SurveyError('Selected time slot is required', this));
      return true;
    }

    return true;
  }
}

Serializer.addClass(
  CUSTOM_RANDOX_POSTCODE_CLINIC_SEARCH_QUESTION_TYPE,
  [],
  function () {
    return new RandoxPostcodeClinicSearch('');
  },
  'question'
);

export class SurveyRandoxPostcodeClinicSearch extends SurveyQuestionElementBase {
  constructor(props: any, bearerToken: string) {
    super(props);
    this.state = { value: this.question.value, model: props.creator.props?.model, bearerToken };
  }
  get question() {
    return this.questionBase;
  }
  get value() {
    return this.question.value;
  }

  // Support the read-only and design modes
  get style() {
    return this.question.getPropertyValue('readOnly') || this.question.isDesignMode
      ? ({ pointerEvents: 'none' } as CSSProperties)
      : undefined;
  }

  renderElement() {
    const onSelectedClinicSlot = (selectedClinicSlot: ClinicSlotSurveyData | undefined) => {
      this.question.value = selectedClinicSlot;
    };

    const setClinicsNotFound = (value: boolean) => {
      this.question.value = { ...this.value, isNotInRandoxCatchment: value };
    };
    return (
      <div style={this.style}>
        <RandoxSearchInput onSelectedClinicSlot={onSelectedClinicSlot} setClinicsNotFound={setClinicsNotFound} />
      </div>
    );
  }
}

ReactQuestionFactory.Instance.registerQuestion(CUSTOM_RANDOX_POSTCODE_CLINIC_SEARCH_QUESTION_TYPE, (props) => {
  // @ts-ignore - React createElement type compatibility issue
  return createElement(SurveyRandoxPostcodeClinicSearch, props);
});

// this bit is needed to tell the survey creator in vl-admin about the new component
const CustomizeRandoxPostcodeClinicSearch = (surveyCreator?: SurveyCreator) => {
  ElementFactory.Instance.registerElement(CUSTOM_RANDOX_POSTCODE_CLINIC_SEARCH_QUESTION_TYPE, (name: string) => {
    return new RandoxPostcodeClinicSearch(name) as IElement;
  });

  if (surveyCreator && !surveyCreator.toolbox.getItemByName(CUSTOM_RANDOX_POSTCODE_CLINIC_SEARCH_QUESTION_TYPE)) {
    surveyCreator.toolbox.addItem({
      name: CUSTOM_RANDOX_POSTCODE_CLINIC_SEARCH_QUESTION_TYPE,
      title: CUSTOM_RANDOX_POSTCODE_CLINIC_SEARCH_QUESTION_TYPE,
      iconName: '',
      json: { type: CUSTOM_RANDOX_POSTCODE_CLINIC_SEARCH_QUESTION_TYPE },
      category: 'Custom Type',
      className: 'svd_custom_type',
      isCopied: false
    });
  }
};

export default CustomizeRandoxPostcodeClinicSearch;
